module.exports = __webpack_public_path__ + "static/media/0011t.01700634.jpg";